import { Home } from "lucide-react"
import { Link } from "react-router"

export const BookingPageHero = () => (
  <section className="overflow-hidden border-b border-white/10 bg-[linear-gradient(105deg,#3F3323_0%,#5A4830_55%,#806C48_100%)] px-5 py-14 text-center text-[#f6f0e7] sm:py-16 lg:py-20">
    <nav
      aria-label="Breadcrumb"
      className="flex items-center justify-center gap-2 text-sm text-[#ead4ad] sm:text-base"
    >
      <Link
        to="/"
        className="inline-flex items-center gap-1.5 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d5b46f]"
      >
        <Home className="size-4 fill-current" aria-hidden="true" />
        Trang chủ
      </Link>
      <span className="text-[#d0a85e]" aria-hidden="true">›</span>
      <span className="font-medium text-white">Đặt phòng</span>
    </nav>

    <h1 className="mt-7 font-serif text-4xl font-semibold leading-none tracking-tight sm:text-5xl lg:text-[56px]">
      Lịch đặt phòng
    </h1>
    <p className="mt-5 text-lg font-medium text-[#f0c982] sm:text-xl">
      Đặt phòng ngay
    </p>
  </section>
)
